// Horizontal Linear Stapper
import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';

import Select from '@mui/material/Select';
import Selectsearch from "react-select"
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import {
	FormGroup,
	Label,
} from 'reactstrap';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import moment from 'moment';
// import DateFnsUtils from '@date-io/date-fns';
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; // Or AdapterMoment, AdapterDayjs, etc.

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

// rct card box
import { RctCardContent } from 'Components/RctCard';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
   allAcademys,
   allStudents,
   allSSCoachMembers,
   allAcademySSCoachList,
   addAcademyAdmin,
   assignAcademyAdmin,
   assignStudentCoach,
   assignedStudentList,
   allAcademyStudentsList,
   deleteAcademyCoach,
   deleteCoachStudent,
   addAcademyStudent,
   assignAllStudentCoach,
   assignAcademyCoach
} from 'Actions';

function getSteps() {
   return ['Select Academy', 'Create or Assign SS Coach', 'Assign Students'];
}


class SSCoachWorkflow extends React.Component {
   static propTypes = {
      classes: PropTypes.object,
   };
   confirmationDialog = React.createRef();
   confirmationStudentDialog = React.createRef();
   UNSAFE_componentWillMount() {
	   this.props.allAcademys();
      this.props.allSSCoachMembers();      
      this.props.allStudents(); 

      const role = localStorage.getItem('user_role');
      const usracademy = localStorage.getItem('user_academy');
      if(role==2){
         this.setState({academy: usracademy});
         this.props.allAcademySSCoachList(usracademy);
      }     
	}

   state = {
      activeStep: 0,
      skipped: new Set(),
      academy:"",
      selcoach:"",
      selectedDate: moment(),
      lstaction:0,
      selstudent:[],
      checkallstudent:0,
   };
   isStepOptional = step => {
      return step === 1;
   };
   isStepSkipped(step) {
      return this.state.skipped.has(step);
   }
   handleNext = () => {
      const { activeStep } = this.state;
      let { skipped } = this.state;
      let { academy } = this.state;
      let { lstaction } = this.state;
      let { selcoach } = this.state;
      let { selstudent } = this.state;
      let { checkallstudent } = this.state;
      if(activeStep==0 && academy==""){
           alert('Please select the academy');     
      }else if(activeStep==1){
          if(lstaction==0 && selcoach==""){
            alert('Please select the SS coach or create SS coach');   
          }else{
            this.props.assignAcademyCoach(academy,selcoach,3).then((data) => {         
               if(data.status==1){
                this.props.assignedStudentList(selcoach,academy);
                this.props.allAcademyStudentsList(academy);
                  this.setState({
                     activeStep: 2,
                  });
                  
               }
            });
           
          }  
      }else if(activeStep==2){ 
         if(checkallstudent==1){
               this.props.assignAllStudentCoach(academy,selcoach).then((data) => {         
                  if(data.status==1){
                     this.setState({
                        activeStep: 3,
                     });
                  
                  }
               });
         }else if(selstudent.length==0){ 
               this.setState({
                  activeStep: 3,
               });
         }else{
               const commaSep = selstudent.join(',');
               this.props.assignStudentCoach(academy,selcoach,commaSep).then((data) => {         
                  if(data.status==1){
                  this.setState({
                     activeStep: 3,
                  });
                  
                  }
               });
         }
        
      }else{
        
         if(this.isStepSkipped(activeStep)) {
            skipped = new Set(skipped.values());
            skipped.delete(activeStep);
         }
         this.setState({
            activeStep: activeStep + 1,
            skipped,
         });
      }
   };

   selAcademy = (evt) =>{
      const academyid=evt.target.value;
      this.setState({academy: academyid});
      this.props.allAcademySSCoachList(academyid);
   }
   handleBack = () => {
      const { activeStep } = this.state;
      this.setState({
         activeStep: activeStep - 1,
      });
   };
  
   handleDateChange = (date) => {
		this.setState({ selectedDate: date });
	};

   addHandleSubmit(event){
      event.preventDefault();
      
      this.props.addAcademyAdmin(event,this.state.academy,this.state.selectedDate,6).then((data) => {         
         if(data.status==1){
            const adcoach=data.data;
            this.viewStudentList(0);
            this.setState({
               selcoach: adcoach,
               lstaction:1,
               activeStep: 2,
            });
            document.getElementById("membersform").reset(); 
         }
      });
      
   }

   addStudentSubmit(event){
      event.preventDefault();
      
      this.props.addAcademyStudent(event,this.state.academy,this.state.selectedDate,this.state.selcoach).then((data) => {         
         if(data.status==1){          
            this.props.assignedStudentList(this.state.selcoach,this.state.academy)
            document.getElementById("membersform").reset(); 
         }
      });
      
   }

   viewStudentList(id){
      let { academy } = this.state;
      this.setState({ selcoach: id });
      this.props.allAcademyStudentsList(academy);
      this.props.assignedStudentList(id,academy).then((data) => {         
         
         this.setState({
            activeStep: 2,
         });
      });
   }

   deleteForm(data){
      let { academy } = this.state;
      this.data = data;
      this.academy = academy
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse){
      
      if (popupResponse) {
          this.props.deleteAcademyCoach(this.data, this.academy,2).then((data) => { 
            this.data = "";  
            this.props.allAcademySSCoachList(this.academy);  
         });
               
      }
      
   }

   deleteStudentForm(data){
      let { academy } = this.state;
      let { selcoach } = this.state;
      this.data = data;
      this.academy = academy;
      this.selcoach = selcoach;
      this.confirmationStudentDialog.current.openDialog();
   }

   deleteStudentPermanent(popupResponse){
      
      if (popupResponse) {
          this.props.deleteCoachStudent(this.data, this.academy, this.selcoach).then((data) => {         
         
            this.data = "";   
            this.props.assignedStudentList(this.selcoach,this.academy)  
         });
               
      }
      
   }

   multiSelectChange = (e) => {
      var value = [];
      for (var i = 0, l = e.length; i < l; i++) {        
         value.push(e[i].value);       
      }    
      this.setState({selstudent: value});
   }

   handleCheckboxChange(e){
      if (e.target.checked) {
         this.setState({checkallstudent: 1});
      }else{
         this.setState({checkallstudent: 0});
      }
   }
 
   render() {
      const steps = getSteps();
      const { activeStep } = this.state;
      const { academylists, sscoachlists, academysscoachlists, studentlists, assignedstudents, academystudentslist, loading } = this.props;

        const allstudent=academystudentslist.map((stdval) => {  
                return {
                label: stdval.student,  
                value: stdval.uudID
                }
        });
      return (
         <div className="hoz-linear-stepper">
            <Stepper alternativeLabel nonLinear activeStep={activeStep}>
               {steps.map((label, index) => {
                  const props = {};
                  const labelProps = {};
                  if (this.isStepOptional(index)) {
                     labelProps.optional = '';
                  }
                  if (this.isStepSkipped(index)) {
                     props.completed = false;
                  }
                  return (
                     <Step key={label} {...props}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                     </Step>
                  );
               })}
            </Stepper>
            <div className="pl-40">
                 
                  {(function(){
                  if (activeStep === 0) {

                  //{activeStep === 0 ? (
                     return <div>

                         <div className="row">
                           <div className="col-md-12">
                             <div className="form-group col-md-6">
                             <FormControl fullWidth>
                                 <InputLabel htmlFor="age-simple">Academy</InputLabel>
                                 <Select value={this.state.academy}  onChange={this.selAcademy}
                                    inputProps={{ name: 'academy', }}>
                                    <MenuItem value=""><em>None</em></MenuItem>                                    
                                    {academylists.map((acdylst) => (
                                         <MenuItem value={acdylst.aadID}>{acdylst.aad_name}</MenuItem>
                                    ))}
                                 </Select>
                                 </FormControl>
                              </div>
                           </div>
                           
                              <Button onClick={this.props.onClick} className="btn-danger text-white mr-3 mb-3" >
                                 Back
                              </Button>
                              <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                                 {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                              </Button>
                           
                        </div>   
                     </div>  
                   } else if (activeStep === 1) { 
                     return <div>
                        <div className="row">
                           <div className="col-md-6">
                              <RctCollapsibleCard colClasses="col-sm-12 col-md-12 col-lg-12 w-xs-full" heading="Academy SS Coaches">
                                 <RctCardContent>
                                    <div className="upcoming-events-wrap">
                                       <List className="list-unstyled p-0">
                                          
                                          {academysscoachlists.map((acdylst) => (
                                             <ListItem className="border-bottom px-0 d-flex justify-content-between align-content-start">
                                                <div>
                                                   <h5><a className="text-primary" onClick={ ()=>this.viewStudentList(acdylst.uudID)}>{acdylst.student}</a></h5>
                                                </div>
                                                <div>
                                                <IconButton className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(acdylst.uudID)}><DeleteOutlineOutlinedIcon/></IconButton>
                                                </div>
                                             </ListItem>
                                          ))}
                                       </List>
                                    </div>
                                 </RctCardContent>
                              </RctCollapsibleCard>
                           </div>
                           <div className="col-md-6">
                              
                              <div className="col-md-12">
                                 <RctCollapsibleCard>
                                 <FormControl fullWidth>
                                    <InputLabel htmlFor="age-simple">Select SS Coach</InputLabel>
                                    <Select value={this.state.selcoach}  onChange={evt => this.setState({selcoach: evt.target.value})}
                                       inputProps={{ name: 'academyadmin', }}>
                                       <MenuItem value=""><em>None</em></MenuItem>                                    
                                       {sscoachlists.map((acdylst) => (
                                          <MenuItem value={acdylst.uudID}>{acdylst.student}</MenuItem>
                                       ))}
                                       
                                    </Select>
                                 </FormControl>
                                 </RctCollapsibleCard>
                              </div>
                              <div className="col-md-12 text-center"> (OR) </div>
                              <div className="col-md-12">
                                 <RctCollapsibleCard>
                                 <form autoComplete="off"  id="membersform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                    <h4>Add Golf Coach</h4>
                                    <div className="form-group">
                                       <TextField  required id="fname" name="fname" fullWidth label="First Name" />
                                    </div>
                                    <div className="form-group">
                                       <TextField required id="lname" name="lname" fullWidth label="Last Name" />
                                    </div>
                                    <div className="form-group">
                                       <TextField  type="email" required id="email" autoComplete="new-email" name="email" fullWidth label="Email" />
                                    </div>
                                    <div className="form-group">
                                       <TextField  type="phone" required id="mobile" name="mobile" fullWidth label="Mobile" />
                                    </div>
                                    <div className="form-group">
                                       
                                       <Fragment>
                                       <div className="rct-picker">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Date of Birth"
            value={this.state.selectedDate}
            onChange={this.handleDateChange}
            inputFormat="yyyy-MM-dd"
            components={{
              LeftArrowIcon: () => <i className="zmdi zmdi-arrow-back" />,
              RightArrowIcon: () => <i className="zmdi zmdi-arrow-forward" />,
            }}
            renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
          />
        </LocalizationProvider>
      </div>
                                       </Fragment>
                                   
                                    </div>
                                    <FormControl fullWidth>
                                       <InputLabel htmlFor="age-simple">Gender</InputLabel>
                                       <Select inputProps={{ name: 'gender', id: 'gender', }} required >
                                          <MenuItem value=""><em>None</em></MenuItem>
                                          <MenuItem value="1"><em>Male</em></MenuItem>
                                          <MenuItem value="2"><em>Female</em></MenuItem>                                   
                                       </Select>
                                    </FormControl> 
                                    <div className="form-group">
                                       <TextField type="password" required id="password" autoComplete="new-password" name="password" fullWidth label="Password" />
                                    </div>
                                    <div className="form-group">
                                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                    </div>
                                 </form>  
                                 </RctCollapsibleCard> 
                              </div>
                           </div>
                           <Button disabled={activeStep === 0} onClick={this.handleBack} className="btn-danger text-white mr-3 mb-3" >
                              Back
                           </Button>
                           <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                              {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                           </Button>
                        </div>   
                     </div>

                   } else if (activeStep === 2) { 
                        return <div>  
                                <div className="row">
                                    <div className="col-md-6">
                                        <RctCollapsibleCard colClasses="col-sm-12 col-md-12 col-lg-12 w-xs-full" heading="Student List">
                                            <RctCardContent>
                                                <div className="upcoming-events-wrap">
                                                <List className="list-unstyled p-0">
                                                    
                                                    {assignedstudents.map((acdylst) => (
                                                        <ListItem className="border-bottom px-0 d-flex justify-content-between align-content-start">
                                                            
                                                            <div>
                                                               <h5><a className="text-primary">{acdylst.student}</a></h5>
                                                            </div>
                                                            <div>
                                                            <IconButton className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteStudentForm(acdylst.uudID)}><DeleteOutlineOutlinedIcon/></IconButton>
                                                            </div>
                                                        </ListItem>
                                                    ))}
                                                </List>
                                                </div>
                                            </RctCardContent>
                                        </RctCollapsibleCard>
                                    </div>
                                    <div className="col-md-6">
                                       <div className="col-sm-12 col-md-12 col-lg-12"> 
                                             <FormGroup>
                                                <Label for="Select">Select Students</Label>
                                                <Selectsearch  isMulti className="form-control h-auto w-100" id="student" name="student" options={allstudent} value={allstudent.find(obj => obj.value === this.state.selstudent)} onChange={this.multiSelectChange} placeholder="Select Students" required/>
                                             </FormGroup>
                                       </div>
                                       <div className="col-md-12 text-center"> (OR) </div>
                                             <FormGroup>
                                             <input
                                                   class="form-check-input form-check-input-lg"
                                                   type="checkbox"
                                                   name="allstudent"
                                                   value={this.state.checkallstudent}
                                                   style={{ height: "1.5rem", width: "1.5rem", position: "relative", marginLeft:"20px" }}
                                                   onChange={(e) => this.handleCheckboxChange(e)}       
                                             /> Select All Students
                                             </FormGroup>
                                       <div className="col-md-12 text-center"> (OR) </div>
                                       <div className="col-md-12">
                                          <RctCollapsibleCard>
                                          <form autoComplete="off"  id="membersform" onSubmit={(e)=>this.addStudentSubmit(e)}>
                                             <h4>Add Student</h4>
                                             <div className="form-group">
                                                <TextField  required id="fname" name="fname" fullWidth label="First Name" autoComplete="off"/>
                                             </div>
                                             <div className="form-group">
                                                <TextField required id="lname" name="lname" fullWidth label="Last Name" autoComplete="off"/>
                                             </div>
                                             <div className="form-group">
                                                <TextField  type="email" required id="email" autoComplete="new-email" name="email" fullWidth label="Email"/>
                                             </div>
                                             <div className="form-group">
                                                <TextField  type="phone" required id="mobile" name="mobile" fullWidth label="Mobile" autoComplete="off"/>
                                             </div>
                                             <div className="form-group">
                                                
                                                <Fragment>
                                                  <div className="rct-picker">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Date of Birth"
            value={this.state.selectedDate}
            onChange={this.handleDateChange}
            inputFormat="yyyy-MM-dd"
            components={{
              LeftArrowIcon: () => <i className="zmdi zmdi-arrow-back" />,
              RightArrowIcon: () => <i className="zmdi zmdi-arrow-forward" />,
            }}
            renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
          />
        </LocalizationProvider>
      </div>
                                                </Fragment>
                                          
                                             </div>
                                             <FormControl fullWidth>
                                                <InputLabel htmlFor="age-simple">Gender</InputLabel>
                                                <Select inputProps={{ name: 'gender', id: 'gender', }} required autoComplete="off">
                                                   <MenuItem value=""><em>None</em></MenuItem>
                                                   <MenuItem value="1"><em>Male</em></MenuItem>
                                                   <MenuItem value="2"><em>Female</em></MenuItem>                                   
                                                </Select>
                                             </FormControl> 
                                             <div className="form-group">
                                                <TextField type="password" required id="password" autoComplete="new-password" name="password" fullWidth label="Password"/>
                                             </div>
                                             <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                             </div>
                                          </form>  
                                          </RctCollapsibleCard> 
                                       </div>
                                    </div>  
                                    <Button disabled={activeStep === 1} onClick={this.handleBack} className="btn-danger text-white mr-3 mb-3" >
                                        Back
                                    </Button>
                                    <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>
                                </div> 
                             </div>

                   }else{
                     return <div>
                           <div className="row">
                              <div className="col-md-12">
                                 <div className="alert bg-success text-white col-sm-12 col-md-6 col-lg-6" role="alert">
                                    <strong>Well done!</strong> You successfully assign ss coach.
                                 </div>
                              </div>
                              <Button onClick={this.props.onClick} className="btn-danger text-white mr-3 mb-3" >
                                 Back to Home
                              </Button>
                           </div>
                     </div>
                   }  
                  }).call(this)} 


                  <ConfirmationDialog
                     ref={this.confirmationDialog}
                     onConfirm={(res) => this.deleteDataPermanent(res)}
                     data={'ss coach'}
                  />

                  <ConfirmationDialog
                     ref={this.confirmationStudentDialog}
                     onConfirm={(res) => this.deleteStudentPermanent(res)}
                     data={'student'}
                  />
                  
            </div>
         </div>
      );
   }
}




const mapStateToProps = ({ academy, mostlyused, workflow }) => {
	const { academylists, loading } = academy;
    const { sscoachlists, academysscoachlists, studentlists, academystudentslist } = mostlyused;
    const { assignedstudents } = workflow;
	return { academylists, sscoachlists, academysscoachlists, studentlists, assignedstudents, academystudentslist, loading };
}

export default connect(mapStateToProps, {
   allAcademys,
   allStudents,
   allSSCoachMembers,
   allAcademySSCoachList,
   addAcademyAdmin,
   assignAcademyAdmin,
   assignStudentCoach,
   assignedStudentList,
   allAcademyStudentsList,
   deleteAcademyCoach,
   deleteCoachStudent,
   addAcademyStudent,
   assignAllStudentCoach,
   assignAcademyCoach
})(SSCoachWorkflow); 
